import { FragmentDefiner, useReadFragment } from "../../../GlobalHooks/useReadFragment";

import { showPropState } from "../../../Utils/Functions";
import { useFilters } from "../Filters.hook";

export const FRAGMENT_PROPSTATES_OPTIONS = new FragmentDefiner(
	"Filter",
	` id
	  name
	  options`
);
export const FRAGMENT_PROPSTATES = new FragmentDefiner(
	"Filters",
	`propStates { ${FRAGMENT_PROPSTATES_OPTIONS.query()} }`
);

export const usePropStates = () => {
	const { filters } = useFilters();

	const show = showPropState(filters?.property_type_id, filters?.operation_type_id);
	const type = "multiple";

	return {
		show,
		data: {
			type: type,
			value: filters?.constStatesID,
		}
	};
};
